module.exports = __webpack_public_path__ + "static/task_pane_customize_template-76813ba2f595293a82b94656d0faaa8d.png";